import $ from 'jquery';
import Parallax from './Parallax';
import JumpMenu from './JumpMenu';

export default class CommunitiesOverview {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.processContent();
    this.addParallax();
    this.listen();
  }

  processContent() {
    const $content = this.$element.find('.node-content');
    const $more = this.$element.find('.content__more');
    const $intro = $more.find('h3:first-of-type, p:first-of-type');
    $intro.prependTo($content);

    // Group all related content which proceeds each h4 heading.
    $content.find('h4').each((i, element) => {
      // Trim crap outta the heading text.
      const text = $(element).text().trim();
      // Create a safe sting for id and classname definitions.
      const safe = text.replace(/ /g, '-').toLowerCase();
      const anchor = $('a', element);
      let outsideLink = '';

      if (anchor.length > 0 && anchor.attr('href') !== undefined) {
        outsideLink = anchor.attr('href');
      }

      if (anchor.length > 0) {
        $(element).append($(element).text());
      }
      // Create our group container.
      const $group = $(document.createElement('div'));
      $group.addClass('group').addClass(safe);
      // Create a anchor to be used by the TOC at the top of the page.
      $group.attr('id', `jump-to-${safe}`);
      // Add our anchor to the jumpmenu component.
      if (outsideLink !== '') {
        JumpMenu.addJumpLink({
          id: `jump-to-${safe}`,
          label: text,
          actualLink: outsideLink,
        });
      } else {
        JumpMenu.addJumpLink({
          id: `jump-to-${safe}`,
          label: text,
        });
      }

      // Reference content between current and next heading.
      const $related = $(element).nextUntil('h4');
      // Add referenced content to the group
      $related.appendTo($group);
      // Place the group before the heading
      $group.insertBefore(element);
      // Prepend the heading inside the group
      $group.prepend(element);
    });

    // Wrap all groups in a wrapper to manage column display
    const groups = document.createElement('div');
    groups.classList.add('groups');
    $content.find('.group').wrapAll(groups);

    // Mark content ready.
    $content.addClass('ready');
  }

  addParallax() {
    return new Parallax(this.element.querySelector('figure img'));
  }

  listen() {
    this.toggle.addEventListener('click', this.clickHandler.bind(this));
  }

  clickHandler() {
    this.toggle.setAttribute('aria-hidden', true);
    this.toggle.setAttribute('aria-expanded', true);
    this.toggle.setAttribute('aria-disabled', true);
  }

  get toggle() {
    return this.element.querySelector('.content__toggle');
  }

  get more() {
    return this.element.querySelector('.content__more');
  }
}
